import React from 'react'
import { Box } from '../../Components/Layout'
import { InnerCon } from './styles'
import { Lk } from '../../Components/Links/Lk'
import { PLL_LINKS } from '../../Config/config'

export const Explainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Box noMargin>
      <InnerCon>
        <Lk link={PLL_LINKS.rules} alt="League Official Rules">League Official Rules</Lk>
        <h2>Roster Designations:</h2>
        <ul>
          <li>
            <strong>Injured List:</strong> Unable to perform due to a lacrosse-related
            injury or ailment sustained during the season.
          </li>
          <li>
            <strong>Unavailable to Travel List:</strong> A Player who has an approved
            excused absence and cannot make the start of the PLL Season. A player on the
            Unavailable to Travel List does not count against the Club's roster limits.
            Once a player is removed from the Unavailable to travel list, he must be
            placed on the clubs active reserve, or inactive roster immediately, or be
            released into the player pool.
          </li>
          <li>
            <strong>PUP List:</strong> Physically Unable to Perform due to injury outside
            of a PLL game.
          </li>
          <li>
            <strong>Holdout List:</strong> Player who fails to report to his club, has
            not been medically cleared, or fails to submit paperwork will be placed on
            the holdout list.
          </li>
          <li>
            <strong>Military Reserve List:</strong> For active duty or training military
            personnel.
          </li>
          <li>
            <strong>Player Pool:</strong> Players signed to the PLL who are not currently
            on an active roster.
          </li>
        </ul>

        <h2>Trade Window</h2>
        <ul>
          <li>
            <strong>Postseason Trade Window:</strong>{' '}
            {`The 2024 postseason trade window opens on November 4, 2024 and closes on December 13, 2024 at 5:00PM ET. It will remain closed until the 2025 player movement period opens on March 3, 2025 at 9:00AM ET.`}
          </li>
        </ul>

        <h2>Free Agency and Other Player Movement</h2>
        <ul>
          <li>
            {`Players whose contracts expire will become eligible for Free Agency. “Free Agency” is a status afforded to Players who are able to negotiate a contract with any Club.`}
          </li>
          <li>
            {`Subject to the above, a Player will become eligible for Free Agency:`}
          </li>
          <ul>
            <li>{`when Player’s existing contract expires; or`}</li>
            <li>
              {`if Player is not on his Club’s Active Roster for 30% or more of “eligible”games in a Season. The Player must remain with his Club for the entirety of the Season, but such Player will become eligible for Free Agency beginning in the off-season.`}
            </li>
            <ul>
              <li>
                {`If a Player is on the Injured List, Family or Medical Leave List, or otherwise excused, the Player is not considered “eligible” to play for that game, and such game will not count against the Club’s 30% threshold.`}
              </li>
            </ul>
            <li>
              {`Additionally, any college graduate who is not drafted in the College Draft may be signed by a Club as a “College Free Agent” at any point in the year in which such player graduated college. Clubs are not permitted to claim a College Free Agent until after the College Draft. All college free agents will go through the waiver process for the first waiver period following the college draft. Following that, all College free agents become free agents and are able to sign with any team, regardless of waiver priority. All College Free Agents will be considered rookies and will be obligated to sign training camp designee contracts.`}
            </li>
          </ul>
          <li>
            {`A player may re-sign with their current team at any point during the year.`}
          </li>
          <li>
            {`2025 free agency begins at 9:00AM ET on Monday March 3, 2025. All players in the player pool or signed to contracts who expire prior to the 2025 player movement window will become free agents.`}
          </li>
          <li>
            {`Other Player Movement. If a Player is on a Club’s Inactive Roster for three (3) consecutive games, he will be eligible for movement via the waiver process. If a Club wishes to pick up the Player, his contract will be assigned to the receiving Club and the Player must be immediately placed on the Club’s Active Roster. If not picked up by another Club, the Player will remain on his current Club Roster`}
          </li>
        </ul>
        
        <h2>Waiver Periods</h2>
        <ul>
          <li>
            {`Special Championship Series Waiver period will open Monday, November 4th at 9:00 ET and close on Friday, December 13th at 2:00 ET`}
          </li>
          <ul>
            <li>
              {`During this period, only teams participating in the championship series may claim players not under contract from the player pool via waivers.`}
            </li>
            <li>
              {`Waivers will run each Tuesday and Friday of the special waiver period.`}
            </li>
            <li>
              {`The Initial waiver order will be the inverse of the 2025 end of season results and can be found below.`}
            </li>
            <ul>
              <li>
                {`Boston Cannons`}
              </li>
              <li>{`New York Atlas`}</li>
              <li>{`Maryland Whipsnakes`}</li>
              <li>{`Utah Archers`}</li>
            </ul>
          </ul>
        </ul>
      </InnerCon>
    </Box>
  )
}
